import { createTheme } from '@one-thd/sui-atomic-components';

const Behr2026Grounded = createTheme({
  palette: {
    mode: 'dark',
    background: {
      primary: 'brand'
    }
  }
});

Behr2026Grounded.palette['--sui-palette-background-primary'] = '86 83 68';

export { Behr2026Grounded };